/** 售卖状态
 * NotBegin - 售卖未开始(敬请期待)
 * PreNotLogin - 售卖前2小时（未登录显示“提前登录”）
 * PreHasLogin - 售卖前2小时（已登录显示“即将开售”）
 * Sell - 售卖中(立即下单)
 * Selling - 售卖中(立即下单 loading)
 * SoldOut - 已售罄
 */
export const SaleStatus = {
    NotBegin: 0,
    PreNotLogin: 1,
    PreHasLogin: 2,
    Sell: 3,
    Selling: 4,
    SoldOut: 5,
};
